import { makeStyles } from "@material-ui/core";
import { Collection, Linked } from "@type-r/models";
import { asCurrency, asTimelessDate, CollapsableSection, Flex, Link, TilesList } from "lqx-react/src";
import React from "react";
import { TimeRangeSelector } from ".";
import { SmallBox } from "../../inmatch/invoices/invoicesList";
import { ListField } from "../../inmatch/matching/unreconciled/invoicesList";
import { TimeRangeTypes } from "../api";

const toMMDDYYYString = (date: Date) => date && `${date.getMonth() + 1}/${date.getUTCDate()}/${date.getFullYear()}`;

export type LandingItemsType = 'unreconciled' | 
    'unresolved-payments' | 
    'unresolved-ras' | 
    'sent-out-invoices' | 
    'approved-invoices' | 
    'auto-reconciled-payments';

export const LandingItems = ({ title, items, linkUrl, type, $timeRange }:
    {
        title: String,
        items: Collection<any>,
        linkUrl: String
        type: LandingItemsType,
        $timeRange?: Linked<number>
    }) => {   
        
        const styles = landingItemStyles();

        return (
            <CollapsableSection 
                title={`${title}`} 
                right={ $timeRange ? 
                    <TimeRangeSelector $timeRange={$timeRange} timeRangeTypes={TimeRangeTypes.slice(0, 4)} /> 
                    : <></>
                       
                }>
                <TilesList
                    items={Array.from(items)}
                    itemSize={60}
                    renderer={LandingOpenItem(linkUrl, type)}
                    selectedItem={null}
                    height={600} />
            </CollapsableSection>
    );
}

const LandingOpenItem = (linkUrl: String, type: LandingItemsType) => ({ data, style, index }) => {
    const item = data.items[index];
    const styles = landingItemStyles();

    const linkText = type == 'unreconciled' || type == 'unresolved-payments' || 'auto-reconciled-payments' ? `${item.count} payments` :
        type == 'unresolved-ras' ? `${item.count} RAs` :
        type == 'sent-out-invoices' || type == 'approved-invoices' ? `${item.count} invoices` : '';

    const linkParams = 
        type == 'unreconciled' || 'auto-reconciled-payments' ? {customerExternalId: item.customerExternalId} :
        type == 'sent-out-invoices' ? {relationshipId: item.relationshipId, sentDateDesc: true} : 
        type == 'approved-invoices' ? {relationshipId: item.relationshipId, hasPromiseToPay: true, lastUpdatedOnDesc: true} : {}
    return (
        <div style={style}>
            <SmallBox>
                {
                    type == 'sent-out-invoices' || type == 'approved-invoices' ?
                        <>
                            <div className={styles.customerDetails} title={item.customerName}>
                                <Flex column>
                                    <ListField className={styles.listField}>{item.customerName}</ListField>
                                    <ListField className={styles.listField}>{item.customerExternalId}</ListField>
                                </Flex>
                            </div>
                            <ListField className={styles.listField}>
                                <Link href={linkUrl} params={linkParams}>
                                    {linkText}
                                </Link>
                            </ListField>
                            <ListField className={styles.amountSum}>Sum: {asCurrency(item.outstandingAmountSum)}</ListField>
                        </> : <></>
                }
                {
                    type == 'unreconciled' || type == 'auto-reconciled-payments'?
                        <>
                            <div className={styles.customerDetails} title={item.customerName}>
                                <Flex column>
                                    <ListField className={styles.listField}>{item.customerName}</ListField>
                                    <ListField className={styles.listField}>{item.customerExternalId}</ListField>
                                </Flex>
                            </div>
                            <ListField className={styles.listField}>
                                <Link href={linkUrl} params={linkParams}>
                                    {linkText}
                                </Link>
                            </ListField>
                            <ListField className={styles.amountSum}>Sum: {asCurrency(item.amountSum)}</ListField>
                        </> : <></>
                }
                {
                    type == 'unresolved-payments' ?
                        <>
                            <ListField className={styles.listField}>{toMMDDYYYString(item.groupDate)}</ListField>
                            <ListField className={styles.listField}>
                                <Link href={linkUrl} params={{valueDate: asTimelessDate(item.groupDate)}}>
                                    {linkText}
                                </Link>
                            </ListField>
                            <ListField className={styles.amountSum}>Sum: {asCurrency(item.amountSum)}</ListField>
                        </> : <></>
                }
                {
                    type == 'unresolved-ras' ?
                        <>
                            <ListField className={styles.listField}>{toMMDDYYYString(item.groupDate)}</ListField>
                            <ListField className={styles.listField}>
                                <Link href={linkUrl} params={{createdOn: asTimelessDate(item.groupDate)}}>
                                    {linkText}
                                </Link>
                            </ListField>
                        </> : <></>
                }                
                <Flex grow></Flex>
            </SmallBox>
        </div>
    )
}

const landingItemStyles = makeStyles({
    customerDetails: {
        width: 220,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap"
    },
    amountSum: {
        width: 200,
        color: "black"
    },
    listField: {
        color: "black"
    },
    timeRangeStyle: {
        maxWidth: 350
    }
});
